module.exports = __webpack_public_path__ + "media/native-apps/orebro-c0ac7f8f.webp";